import { Badge } from "@capacit-com/lara-law-shared-ui";
import {
  dateValue,
  metadataStyle,
} from "../../../../../utils/legislationMetadataUtils";

export type StandardMetadataTypes = string | string[] | boolean | number | null;

export const MetadataItem = ({
  title,
  metadata,
  isLongText = false,
}: {
  title: string;
  metadata?: StandardMetadataTypes | undefined;
  isLongText?: boolean;
}) => {
  if (isLongText && typeof metadata === "string") {
    return (
      <div className="mt-2 mb-4">
        <h3 className="font-semibold mb-1">{title}</h3>
        {metadata.includes("http") ? (
          <a href={metadata} target="_blank" rel="noopener noreferrer">
            {metadata}
          </a>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: metadata ?? "",
            }}
            className="whitespace-pre-wrap text-sm text-muted-foreground leading-relaxed border-l-2 border-accent pl-3 py-1 rounded-sm"
          />
        )}
      </div>
    );
  }
  if (typeof metadata === "boolean") {
    return (
      <div>
        <p className={metadataStyle.metadataTitleStyle}>{title}</p>
        <Badge variant={metadata ? "success" : "secondary"}>
          {" "}
          {metadata ? "Ja" : "Nej"}
        </Badge>
      </div>
    );
  }

  if (Array.isArray(metadata) && metadata.length > 0) {
    const formatted = metadata.map((item) => {
      const str =
        typeof item === "string" ? item : (item as { value: string }).value;
      // if item includes ' ' we can assume that this data is already formatted
      if (item.includes(" ")) {
        return item.charAt(0).toUpperCase() + item.slice(1);
      } else {
        return (
          //make first letter uppercase
          str.charAt(0).toUpperCase() +
          str
            .slice(1)
            //replace all '-' and '_' which has a character on both sides
            .replace(/(?<=[^\s_-])[_-](?=[^\s_-])/g, " ")
            // replace all '-_' with '- '
            .replace(/-_/g, "- ")
        );
      }
    });

    return (
      <div className="min-w-0">
        <p className={metadataStyle.metadataTitleStyle}>{title}</p>
        <div className="flex flex-wrap gap-y-1">
          {formatted.map((item) => (
            <Badge className="mr-2">{item}</Badge>
          ))}
        </div>
      </div>
    );
  }

  if (typeof metadata === "string" && metadata !== "") {
    const canParseToDate = !isNaN(new Date(metadata as string).getTime());
    if (canParseToDate) {
      //checks if the metadata actually can be converted to a date
      const formattedDate = dateValue(metadata);
      return (
        <div>
          <p className={metadataStyle.metadataTitleStyle}>{title}</p>
          <p className={metadataStyle.metadataValueStyle}>{formattedDate}</p>
        </div>
      );
    }
    return (
      <div>
        <p className={metadataStyle.metadataTitleStyle}>{title}</p>
        {metadata.includes("http") ? (
          <a
            href={metadata}
            target="_blank"
            rel="noopener noreferrer"
            className={metadataStyle.metadataValueStyle + " underline"}
          >
            {metadata}
          </a>
        ) : (
          <p className={metadataStyle.metadataValueStyle}>{metadata}</p>
        )}
      </div>
    );
  }
  if (typeof metadata === "number") {
    return (
      <div>
        <p className={metadataStyle.metadataTitleStyle}>{title}</p>
        <p className={metadataStyle.metadataValueStyle}>{metadata}</p>
      </div>
    );
  }
  return null;
};
